import { formatCurrency } from "@offstreetparking/design-system/formatters";
import type { SummaryProps } from "../paymentScheduleSummary";

export const PerPeriodAmount = ({ overview, locale, currency }: SummaryProps) => {
	const perPeriodAmount = formatCurrency({ locale, valueInCents: overview.perPeriodAmountInCents, currency });

	if (!overview.remainderDeductions) {
		return <>{perPeriodAmount}</>;
	}

	return <>{perPeriodAmount}*</>;
};
